import React, { useRef } from "react";

import { Box, Popover, Typography } from "@material-ui/core";

import { InsightsStrings, primaryMenuString, valueStrings } from "constants/constantStrings";

import smartInsights from "../../../assets/Insights/smart_Insights.svg";

import "./index.scss";

const InsightsSummary = ({ descriptionText }) => {
  const descriptionRef = useRef(null);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const onFocusOnHere = event => {
    if (event) setAnchorEl(event.currentTarget);
  };

  return (
    <>
      <span ref={descriptionRef} className="descriptionText">
        {descriptionText}
      </span>
      <span className="summary-help" onMouseEnter={onFocusOnHere}>
        {valueStrings.here}
      </span>
      {"."}
      <Popover
        anchorEl={anchorEl}
        open={open}
        id={open ? "simple-popover" : undefined}
        onClose={() => {
          setAnchorEl(null);
        }}
        transformOrigin={{
          horizontal: "center",
          vertical: "top"
        }}
        anchorOrigin={{
          horizontal: "center",
          vertical: "bottom"
        }}
        PaperProps={{
          style: {
            backgroundColor: "transparent",
            boxShadow: "none",
            borderRadius: 0
          }
        }}
      >
        <Box
          sx={{
            position: "relative",
            mt: "10px",
            "&::before": {
              backgroundColor: "var(--color-primary)",
              content: '""',
              display: "block",
              position: "absolute",
              width: 12,
              height: 12,
              top: -6,
              transform: "rotate(45deg)",
              left: "calc(50% - 6px)"
            }
          }}
        />
        <Typography>
          <div className="summary-content">
            <h1>{primaryMenuString.smartInsights}</h1>
            <div className="d-flex">
              <p>{InsightsStrings.insightSummary}</p>
              <img src={smartInsights} alt="insights" />
            </div>
            <p>
              {InsightsStrings.insightSummarySecondary} {InsightsStrings.contactAdmin}
            </p>
          </div>
        </Typography>
      </Popover>
    </>
  );
};

export default InsightsSummary;
